export default __webpack_public_path__ + "static/media/2123.c7a66e60.png";